const TRANSMITTABLE_STATUSES = new Set(['OPENED', 'ERROR']);

export interface TransmitBatchInput {
  status: string;
  isManualProcessing: boolean;
  itemCount: number;
}

export interface TransmitBatchEligibility {
  allowed: boolean;
  reason?: string;
}

export function canTransmitBatch(batch: TransmitBatchInput): TransmitBatchEligibility {
  if (batch.isManualProcessing) {
    return {
      allowed: false,
      reason:
        'Lote em processamento manual não pode ser transmitido automaticamente. Desative o modo manual ou feche o lote na Yelum.',
    };
  }

  if (!TRANSMITTABLE_STATUSES.has(batch.status)) {
    return {
      allowed: false,
      reason: 'Só é possível transmitir lotes com status Aberto ou Erro.',
    };
  }

  if (batch.itemCount === 0) {
    return {
      allowed: false,
      reason: 'Lote sem itens ativos para transmitir.',
    };
  }

  return { allowed: true };
}
